//
import { required } from "@/services/validations"
import ProductModel from "@/models/Warehouse/WhProduct"
import UserModel from "@/models/General/GUser"
import WarehouseModel from "@/models/Warehouse/WhWarehouse"

//
import StockAdjustDetailHeaders from "./headers"

//
export default [
    {
        name: "g_user_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "full_name",
            itemValue: "id",
            label: "Responsable",
            loadingText: "Cargando empleados...",
            model: UserModel,
            noDataText: "Sin empleados.",
            noObject: true,
            rules: [ required ],
        },
    },
    {
        name: "wh_warehouse_from_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Origen",
            loadingText: "Cargando bodegas...",
            model: WarehouseModel,
            noDataText: "Sin bodegas.",
            noObject: true,
            rules: [ required ],
        },
    },
    {
        name: "wh_product_to_repackage_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Producto",
            loadingText: "Cargando productos...",
            model: ProductModel,
            noDataText: "Sin productos.",
            noObject: true,
            paramSearch: "search",
            rules: [ required ],
        },
    },
    {
        name: "wh_warehouse_to_id",
        type: "autocomplete-model",
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            chips: true,
            itemText: "name",
            itemValue: "id",
            label: "Destino",
            loadingText: "Cargando bodegas...",
            model: WarehouseModel,
            noDataText: "Sin bodegas.",
            noObject: true,
            rules: [ required ],
        },
    },
    {
        name: "wh_selected_products",
        type: "table-field",
        flex: {
            "pt-0": true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: "v-card elevation-2 mb-4",
            headers: StockAdjustDetailHeaders,
            noActions: true,
            noDataText: "Sin productos.",
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,
            label: "Items",
            rules: [ required ],
            showNativePagination: true,
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: "Lista de productos incluidos en el reenvasado",
            toolbarColor: "primary",
            toolbarDark: true,
            toolbarDense: true,
        },
    },
    {
        name: "comment",
        type: "textarea",
        flex: {
            xs12: true,
        },
        props: {
            label: "Comentarios",
        },
    },
    /*{
        name: "is_opened",
        type: "switch",
        flex: {
            xs12: true,
        },
        props: {
            label: "El producto se encuentra abierto.",
            rules: [ required ],
        },
    },*/
]